<div class="responsive-container"
     [class.show-left-shadow]="canScrollLeft"
     [class.show-right-shadow]="canScrollRight"
     (scroll)="onScrollChange()"
     #container>
  <ng-content></ng-content>
</div>
